import React from 'react'
import { Stack, Box, Divider, Typography, Checkbox } from '@mui/material'
import { styled } from '@mui/material/styles'
import { TExtraPartsItem } from '~/src/types/instruction'

const ItemBodyText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'left',
  color: '#000000DE', //theme.palette.mode === 'dark' ? '#000000DE' : '#fff',
  fontWeight: '400',
  letterSpacing: '0.15px',
  lineHeight: '20px',
  fontSize: '14px',
}))

const ItemBodyDisableText = styled(ItemBodyText)(({ theme }) => ({
  color: '#999999', //theme.palette.mode === 'dark' ? '#000000DE' : '#fff',
  textDecoration: 'line-through',
}))

/**
 * InstructionExtraPartsBody
 *
 * @param __namedParameters TExtraPartsItem
 * @returns JSX.Element
 * @category ReactComponents
 */
export const InstructionExtraPartsBody: React.FC<TExtraPartsItem> = ({
  itemName = '',
  orderName = '',
  status = '',
}) => {
  const label = { inputProps: { 'aria-label': orderName } }
  return (
    <>
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem sx={{ borderColor: '#fff' }} />}
        spacing={2}
        marginX={2}
        padding={2}
        height={'56px'}
      >
        <Box width={'50%'}>
          {status !== '' ? (
            <ItemBodyText>{itemName}</ItemBodyText>
          ) : (
            <ItemBodyDisableText>{itemName}</ItemBodyDisableText>
          )}
        </Box>
        <Box width={'50%'} marginLeft={2}>
          <Box marginLeft={2}>
            {status !== '' ? (
              <Checkbox {...label} checked disableRipple sx={{ padding: 0 }} />
            ) : (
              <ItemBodyText>no available</ItemBodyText>
            )}
          </Box>
        </Box>
      </Stack>
      <Divider />
    </>
  )
}
